import { defineMessages, IntlShape } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/types/entity";

import { getDisplayName } from "@app/util/ui";

enum GlobalSearchFilter {
  ALL = "all",
  COMPANIES = "companies",
  PEOPLE = "people",
  DEALS = "deals",
  GROUPS = "groups",
  ACTIVITIES = "activities",
  ROUTES = "routes",
  TERRITORIES = "territories",
  RESOURCES = "resources",
  USERS = "users",
}

const messages = defineMessages({
  [GlobalSearchFilter.ACTIVITIES]: {
    id: "@component.globalSearch.filter.activities",
    defaultMessage: "Activities",
    description: "Global search filter - Activities",
  },
  [GlobalSearchFilter.ALL]: {
    id: "@component.globalSearch.filter.all",
    defaultMessage: "All",
    description: "Global search filter - All",
  },
  [GlobalSearchFilter.COMPANIES]: {
    id: "@component.globalSearch.filter.companies",
    defaultMessage: "Companies",
    description: "Global search filter - Companies",
  },
  [GlobalSearchFilter.DEALS]: {
    id: "@component.globalSearch.filter.deals",
    defaultMessage: "Deals",
    description: "Global search filter - Deals",
  },
  [GlobalSearchFilter.GROUPS]: {
    id: "@component.globalSearch.filter.groups",
    defaultMessage: "Groups",
    description: "Global search filter - Groups",
  },
  [GlobalSearchFilter.PEOPLE]: {
    id: "@component.globalSearch.filter.people",
    defaultMessage: "People",
    description: "Global search filter - People",
  },
  [GlobalSearchFilter.RESOURCES]: {
    id: "@component.globalSearch.filter.resources",
    defaultMessage: "Resources",
    description: "Global search filter - Resources",
  },
  [GlobalSearchFilter.ROUTES]: {
    id: "@component.globalSearch.filter.routes",
    defaultMessage: "Routes",
    description: "Global search filter - Routes",
  },
  [GlobalSearchFilter.TERRITORIES]: {
    id: "@component.globalSearch.filter.territories",
    defaultMessage: "Territories",
    description: "Global search filter - Territories",
  },
  [GlobalSearchFilter.USERS]: {
    id: "@component.globalSearch.filter.users",
    defaultMessage: "Team Members",
    description: "Global search filter - Users",
  },
});

export const getGlobalSearchFilterValue = (
  filter: GlobalSearchFilter
): EntityType[] | undefined => {
  return {
    [GlobalSearchFilter.ACTIVITIES]: [EntityType.ACTIVITY],
    [GlobalSearchFilter.ALL]: undefined,
    [GlobalSearchFilter.COMPANIES]: [EntityType.COMPANY],
    [GlobalSearchFilter.DEALS]: [EntityType.DEAL],
    [GlobalSearchFilter.GROUPS]: [
      EntityType.COMPANY_GROUP,
      EntityType.PEOPLE_GROUP,
      EntityType.DEAL_GROUP,
    ],
    [GlobalSearchFilter.PEOPLE]: [EntityType.PERSON],
    [GlobalSearchFilter.RESOURCES]: [EntityType.RESOURCE],
    [GlobalSearchFilter.ROUTES]: [EntityType.ROUTE],
    [GlobalSearchFilter.TERRITORIES]: [EntityType.TERRITORY],
    [GlobalSearchFilter.USERS]: [EntityType.USER],
  }[filter];
};

export const getGlobalSearchFilterDisplayName = (intl: IntlShape, filter: GlobalSearchFilter) =>
  getDisplayName(intl, messages, filter, "GlobalSearchFilter");

export default GlobalSearchFilter;
